import ReviewItem from './reviewItem'

export default class ShopReviews extends HTMLElement {
    private cloudflareUrl: string | null = 'https://rodeo-wrangler.hi-f17.workers.dev/'
    private ratingSource: string | null = null
    private klaviyoReviewsSource: string | null = null
    private klaviyoReviewsGroupId: string | null = null

    private embla: any = null
    private viewportEl: HTMLElement | null = null
    private prevButtonEl: HTMLElement | null = null
    private nextButtonEl: HTMLElement | null = null
    private carouselContainer: HTMLElement | null = null
    private ratingEl: HTMLElement | null = null
    private totalReviewsEl: HTMLElement | null = null

    constructor() {
        super()

        this.ratingSource = this.getAttribute('rating-source')

        this.viewportEl = this.querySelector('.embla__viewport') as HTMLElement
        this.carouselContainer = this.querySelector('[data-carousel-container]')
        this.prevButtonEl = this.querySelector('[data-button-prev]')
        this.nextButtonEl = this.querySelector('[data-button-next]')
        this.ratingEl = this.querySelector('[data-rating]')
        this.totalReviewsEl = this.querySelector('[data-total-reviews]')

        this.prevButtonEl?.addEventListener('click', this.handlePrevClick.bind(this))
        this.nextButtonEl?.addEventListener('click', this.handleNextClick.bind(this))

        // If the rating source is not klaviyo, we don't need to fetch reviews

        if (this.ratingSource && this.ratingSource !== 'klaviyo') {
            return
        }

        this.klaviyoReviewsSource = this.getAttribute('klaviyo-reviews-source') ?? 'all'
        this.klaviyoReviewsGroupId = this.getAttribute('klaviyo-reviews-group-id')

        this.fetchKlaviyoReviews()
    }

    private async fetchKlaviyoReviews() {
        let url = `${this.cloudflareUrl}`

        if (this.klaviyoReviewsSource === 'product') {
            url = `${url}${this.klaviyoReviewsSource}`
        }

        if (this.klaviyoReviewsSource === 'group') {
            url = `${url}${this.klaviyoReviewsGroupId}`
        }

        const options = {
            method: 'GET',
        }

        try {
            const response = await fetch(url, options)
            const data = await response.json()

            console.log('data', data)

            if (data && Array.isArray(data.data)) {
                this.renderReviews(data.data)
                this.updateReviewStats(data.data)
            }
        } catch (error) {
            console.error('Error fetching Klaviyo reviews:', error)
        }
    }

    /**
     * Render the reviews in the carousel
     * @param reviews Array of review data from Klaviyo
     */
    private renderReviews(reviews: any[]) {
        if (!this.carouselContainer || !reviews.length) return

        // Clear any existing reviews
        const existingManualReviews = Array.from(this.carouselContainer.children)

        const filteredReviews = reviews.filter((review) => review.attributes.rating !== null && review.attributes.content !== null)

        filteredReviews.forEach((review) => {
            // Create a new review item element
            const reviewItem = new ReviewItem()

            const { author, rating, smart_quote, content } = review.attributes

            reviewItem.setReviewData({
                name: author || 'Anonymous',
                rating: rating || 5,
                title: smart_quote || '',
                description: content || '',
            })

            // Append to the carousel container
            if (this.carouselContainer) {
                this.carouselContainer.appendChild(reviewItem)
            }
        })

        // Refresh the carousel if it's already initialized
        if (this.embla) {
            this.embla.reInit()
        }
    }

    /**
     * Update the review statistics (average rating and total reviews)
     * @param data The review data from Klaviyo
     */
    private updateReviewStats(data: any) {
        if (!data) return

        // Update average rating
        if (this.ratingEl && data.average_rating) {
            this.ratingEl.textContent = `Average Rating: ${data.average_rating.toFixed(1)}/5`
        }

        // Update total reviews
        if (this.totalReviewsEl && data.reviews) {
            this.totalReviewsEl.textContent = `${data.reviews.length} Reviews`
        }
    }

    connectedCallback() {
        if (this.viewportEl) {
            import('embla-carousel').then((EmblaCarousel) => {
                if (this.viewportEl) {
                    this.embla = EmblaCarousel.default(this.viewportEl, {
                        loop: true,
                        align: 'start',
                    })
                }
            })
        }
    }

    disconnectedCallback() {
        if (this.embla) {
            this.embla.destroy()
        }
    }

    handlePrevClick() {
        this.embla?.scrollPrev()
    }

    handleNextClick() {
        this.embla?.scrollNext()
    }
}

customElements.define('shop-reviews', ShopReviews)
